export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/Loader.7ea7998f.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};